import { render, staticRenderFns } from "./pushListModal.vue?vue&type=template&id=283f5554&scoped=true&"
import script from "./pushListModal.vue?vue&type=script&lang=js&"
export * from "./pushListModal.vue?vue&type=script&lang=js&"
import style0 from "./pushListModal.vue?vue&type=style&index=0&id=283f5554&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f5554",
  null
  
)

export default component.exports